// @flow
import React from 'react';
import type { Node } from 'react';
import { Checkbox, FormControlLabel, Typography } from '@mui/material';

type FormFieldCheckboxProps = {
  field: Object,
  onChange: Function,
  value: string,
  error: string,
  styles?: Object,
  disabled?: boolean,
};

const FormFieldCheckbox = ({
  styles = {},
  field,
  onChange,
  value,
  error,
  disabled = false,
}: FormFieldCheckboxProps): Node => {
  const { key, type, label, ...otherFieldProps } = field;

  return (
    <FormControlLabel
      control={
        <Checkbox
          {...otherFieldProps}
          checked={Boolean(value)}
          onChange={onChange}
          error={error && Boolean(error)}
        />
      }
      label={
        <Typography variant="inherit" sx={styles && styles.checkboxLabel}>
          {label}
        </Typography>
      }
      disabled={disabled}
      sx={styles && styles.checkboxControl}
    />
  );
};

export default FormFieldCheckbox;
